import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { MissionRecord, MissionVersionDto } from '@trajectory/contracts';
import { apiFetch } from '@/lib/api';

export function useMissionVersions(missionId: string | null) {
  return useQuery({
    queryKey: ['mission-versions', missionId],
    queryFn: () => apiFetch<MissionVersionDto[]>(`/missions/${missionId}/versions`),
    enabled: missionId !== null,
  });
}

export function useRestoreMissionVersion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ missionId, version }: { missionId: string; version: number }) =>
      apiFetch<MissionRecord>(`/missions/${missionId}/versions/${version}/restore`, { method: 'POST' }),
    onSuccess: (_result, { missionId }) => {
      queryClient.invalidateQueries({ queryKey: ['mission-versions', missionId] });
      queryClient.invalidateQueries({ queryKey: ['missions'] });
    },
  });
}
